
export default function getWFD(sentence1, sentence2) {
    const words1 = sentence1.replace(/[,.]/g, "").replace(/\s+/g, ' ').split(' ').map(v => v.split('/').map(v1 => v1
        .startsWith('^') ? v1.replace(/\^/g, '') : v1.toLowerCase()).join('/'));
    const words2 = sentence2.replace(/[,.]/g, "").replace(/\s+/g, ' ').split(' ');
    let index1 = -1
    let index2 = -1
    let part = null
    let parts = []
    for (let i = 0; i < words2.length; i++) {
        part = []
        index1 = words1.findIndex(v => v.split('/').indexOf(words2[i]) != -1 || v.split('/').indexOf(words2[i]
            .toLowerCase()) != -1)
        if (index1 != -1) {
            index2 = i
            for (let j = index1; j < words1.length; j++) {
                if (words2[index2] && (words1[j].split('/').indexOf(words2[index2]) != -1 || words1[j].split('/').indexOf(words2[index2].toLowerCase()) != -1)) {
                    part.push(words2[index2])
                    index2++
                    if (part.length > 1) i++
                } else {
                    break
                }
            }
        }
        parts.push([words2[i], part, index1])
    }
    let words = []
    let index = 0
    parts.forEach(part => {
        if (part[1].length > 0) {
            if (index < part[2]) {
                words1.slice(index, part[2]).forEach(m => {
                    words.push({
                        word: '(' + m + ')',
                        class: 'wrong1'
                    })
                })
            }
            part[1].forEach(p => {
                words.push({
                    word: p,
                    class: 'right'
                })
            })
            index = part[1].length + part[2]
        } else {
            words.push({
                word: part[0],
                class: 'wrong2'
            })
        }
    })
    words.forEach((w, i) => {
        if (w.class == 'wrong1') {
            const count1 = words1.filter(v => '(' + v.toLowerCase() + ')' == w.word.toLowerCase()).length
            const count2 = words.filter(v => w.word.toLowerCase() == v.word.toLowerCase() || ('(' + v.word
                .toLowerCase() + ')' == w.word.toLowerCase())).length
            if (count2 > count1) {
                let item = words.find((v, j) => j > i && v.word.toLowerCase() == w.word.toLowerCase())
                if (item) w.word = ''
            }
        }
    })

    words = words.filter(v => v.word != '')
    words.forEach(w => {
        if (w.class == 'wrong1') {
            const count1 = words1.filter(v => '(' + v.toLowerCase() + ')' == w.word.toLowerCase()).length
            const count2 = words.filter(v => w.word.toLowerCase() == v.word.toLowerCase() || ('(' + v.word
                .toLowerCase() + ')' == w.word.toLowerCase())).length
            if (count2 > count1) {
                let item = words.find(v => v.flag == undefined && v.class == 'right' && '(' + v.word
                    .toLowerCase() + ')' == w.word.toLowerCase())
                if (item) {
                    item.flag = 1
                    w.word = ''
                }
            }

        }
    })

    //去重
    words = words.filter(v => v.word != '')

    const others = words1.filter(v => words.findIndex(v1 => v1.word.replace(/\W/g, '') == v) == -1)
    if (others.length > 0) {
        words.push({
            word: '(' + others.join(' ') + ')',
            class: 'wrong1'
        })
    }

    if (sentence2.endsWith('.')) {
        words[words.length - 1].word += '.'
    }
    return words;
}



// // // 测试
// const sentence1 = 'Students are advised that all the lectures today have been canceled/cancelled.'
// const sentence2 = 'the students are advisced that the all lectures today have been canceled cancelled.'

// const sentence1 = 'The new technician dropped the microscope in the biology lab.'
// const sentence2 = 'The new technician dropped microscope in the biology lab.'
// const result3 = getWFD(sentence1, sentence2);
// console.log("所有连续匹配:", result3);

